import { ArrowLeft, ShieldCheck } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { PrivacySettingsPanel } from "../components/legal/PrivacySettingsPanel";

export default function PrivacySettings() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#040508] text-white">
      <div className="fixed inset-0 pointer-events-none">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_0%,rgba(245,158,11,0.13),transparent_36%),radial-gradient(circle_at_80%_20%,rgba(244,63,94,0.08),transparent_34%)]" />
      </div>

      <main className="relative z-10 mx-auto max-w-6xl px-4 py-8 md:px-6 md:py-12">
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="mb-8 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.04] px-4 py-2 text-[10px] font-black uppercase tracking-[0.24em] text-white/60 transition hover:bg-white/10 hover:text-white"
        >
          <ArrowLeft size={14} />
          Back
        </button>

        <header className="mb-6 rounded-[34px] border border-white/10 bg-white/[0.045] p-6 shadow-[0_30px_100px_rgba(0,0,0,0.45)] backdrop-blur-xl md:p-9">
          <div className="inline-flex items-center gap-2 rounded-full border border-amber-300/20 bg-amber-300/10 px-4 py-2 text-amber-100">
            <ShieldCheck size={14} />
            <span className="text-[9px] font-black uppercase tracking-[0.3em]">Privacy Center</span>
          </div>

          <h1 className="mt-6 text-2xl font-light tracking-[-0.06em] md:text-4xl">
            Your LRNSY data choices.
          </h1>

          <p className="mt-5 max-w-3xl text-sm leading-7 text-white/58 md:text-base md:leading-8">
            Control optional analytics, marketing attribution, local drafts, and browser storage
            choices without disrupting the emotional experience LRNSY is built for.
          </p>
        </header>

        <PrivacySettingsPanel />
      </main>
    </div>
  );
}
